import DataServiceSQL from "../../DataService/DataServiceSQL";
import ringer from "../../Images/Sounds/ring.wav";
import Utils from '../Common/Utils.js';

const getAudioInstance = () => {       
    const audio = new Audio(ringer); 
    return (audio);
}

//Function to play audio alert
const playAudioAlert = (audio, isSoundActivated) => {
    if(isSoundActivated){
        audio.loop = true;
        audio.autoplay=true;
        audio.play();        
    }
} 

//Function to reset audio alert
const resetAudioAlert = (audio) => {
    audio.loop = false;
    audio.pause();
    audio.currentTime = 0; 
} 


//Function to compare if time between 2 dates exceeds delay
const checkDelayFrontend = (paramDelay, last_alert_date, current_alert_date) => {

    let ret = false;
    if (last_alert_date !== "none") {
    let elapsedTimeInMin = (new Date(current_alert_date) - new Date(last_alert_date)) / 60000;
    if (
            (elapsedTimeInMin >= paramDelay)
    ){
            ret = true;
    }
    }
    return ret;
}


//Function to indicate alert condition if data is equal or over the threshold (common to temperature, PR and SP02)
const checkAlertFrontend = (new_data, alert_params) => {

    let alert = false;

    if(new_data !== "nc"){               // sanitary check    
        if (
            (   
                ((alert_params.sup_or_inf === 'sup') && (new_data >= alert_params.threshold)) 
                ||
                ((alert_params.sup_or_inf === 'inf') && (new_data <= alert_params.threshold))
            )
            ||
            (
                (alert_params.threshold2 !== null) && 
                (   ((alert_params.sup_or_inf2 === 'sup') && (new_data >= alert_params.threshold2))
                 || ((alert_params.sup_or_inf2 === 'inf') && (new_data <= alert_params.threshold2))
                )
            )
           )
        {        
            alert = true;
        }
    }
    return (alert);
}

         

const manageFrontendAlerts = (current_alert, alert_params, alert_type, dataset, audio, audio_activation) => {

    // Period mode ("threshold exceeded X times over a period"): the backend replaces the
    // immediate trigger, so the browser must not ring/highlight on a single breach.
    // Fired period alerts still surface through alerts_triggered (table_alert).
    if (alert_params.threshold_exceeded_count !== undefined && parseInt(alert_params.threshold_exceeded_count) >= 2) {
        return current_alert;
    }

    if(alert_params.activated){
        // select last data
        let lastData = AlertManager.getDataSinceLastAlertCheck(dataset, current_alert.last_read_time);
        if (lastData.length > 0){
            current_alert.last_read_time = lastData[lastData.length-1].x;
        }
        // check alerts
        current_alert = setFrontendAlerts(current_alert, alert_params, alert_type, lastData, audio, audio_activation, dataset);
        // Reset alerts
        current_alert = resetFrontendAlert(current_alert, alert_params, alert_type)
    }
    return current_alert;
}

//Function to set alerts common to fever, detach, pulse rate & spo2
const setFrontendAlerts = (current_alert, alert_params, alert_type, data, audio, audio_activation, dataset) => {

    // if alert activated & not during rest duration
    if( (alert_params.activated) && (!current_alert.active_rest_duration) && (alert_params.threshold !== null) && (alert_params.delay !== null)){

        let single_trig_per_period = false;

        for (var i = 0; i < data.length; i++){ 
            let new_data = data[i];
            let ret = 0
            let j = 0
            let values
            switch (alert_type) {
                case "mdasi_alert" :
                    values = JSON.parse(new_data.y)
                while (values[j]) {
                    if (values[j].label !== "form_type" && values[j].value > ret) {
                        ret = values[j].value
                    }
                    j++;
                }
                new_data.y = ret
                    break
                case "breathing_rate_alert" :
                    values = new_data.y
                    if (values !== undefined && values !== null) {
                        new_data.y = parseInt(new_data.y)
                        }
                    break
                case "breathing_oxygen_rate_alert" :
                    values = new_data.y
                    if (values !== undefined && values !== null) {
                        new_data.y = parseInt(new_data.y)
                        }
                    break
                //Dealing with the breathing leakage special case: the data used should be average on 24 hours
                case "breathing_leakage_alert" :
                    let date_list = []
                    let respiratory_leak_curve = []
                    dataset.forEach((res, i) => {
                        //get the data leak value
                        let resp_value = Number(res.y)
                        //get the datetime of the data
                        let convertedDate = Utils.dateToMidnight(res.x)

                        // Search in tmp date_list if same date already stored
                        let date_list_index = date_list.findIndex((e) => e.date.getTime() === convertedDate.getTime())
                        //if the date_list doesn't contain the day, push the value and set nb val to 1
                        if (date_list_index === -1) {
                            date_list.push({date: convertedDate, total: resp_value, parts: 1})
                        }
                        else {
                            // Add value
                            let temp_value = date_list[date_list_index].total + resp_value
                            // increase nb val
                            let part_value = date_list[date_list_index].parts + 1
                            date_list[date_list_index] = {date: convertedDate, total: temp_value, parts: part_value}
                        }
                    })

                    //for each day with data
                    for (var k = date_list.length-1; k >= 0; k--){
                        // Compute average
                        respiratory_leak_curve.push(  {x: date_list[i].date, y: date_list[i].total / date_list[i].parts});
                    }
                    new_data.y = respiratory_leak_curve[respiratory_leak_curve.length-1].y
                    break
            }

            // if alert not already trig during period & data are correct 
            if((!single_trig_per_period)&&(new_data !== undefined)){
        
                // Check alert condition                
                if(checkAlertFrontend(new_data.y, alert_params)){

                    // Record date of first alert condition
                    if (current_alert.first_detect_time === "none"){      // to be reset when clicking alert clearing cross
                        console.log(alert_type + " first detect at " + new Date(new_data.x).toISOString() + " " + new_data.y)                    
                        current_alert.first_detect_time = new Date(new_data.x);  
                    }    
                
                    // Set alert if delay exceeded
                    if(checkDelayFrontend(alert_params.delay, current_alert.first_detect_time, new_data.x)){
                        console.log(alert_type + " triggered at " + new Date(new_data.x).toISOString() + " " + new_data.y)                    
                        
                        current_alert.triggered = true;
                        current_alert.active_rest_duration = true;
                        single_trig_per_period = true;                                  

                        playAudioAlert(audio,audio_activation); 
                    }
                }
            }
        }
    }

    return current_alert;              
}


// RESET ALERT if 1) Alert not triggered after delay + trig_duration or 2) Alert has triggered and rest_duration has passed
const resetFrontendAlert = (current_alert, alert_param, alert_type) => {

    if (current_alert.first_detect_time !== "none") {    // Only if ongoing alert

        let current_date = new Date();
        let delayAlertNotTriggered  = alert_param.delay + alert_param.trig_duration;
        let delayAlertTriggered     = alert_param.delay + alert_param.trig_duration + alert_param.rest_duration;

        if (
                ((checkDelayFrontend(delayAlertNotTriggered, current_alert.first_detect_time, current_date))   && (current_alert.trig === false))
            ||  ( checkDelayFrontend(delayAlertTriggered, current_alert.first_detect_time, current_date)       && (current_alert.trig === true))
        ){
            console.log(alert_type + " resetting ")
            current_alert.first_detect_time = "none";
            current_alert.active_rest_duration = false;
        }   
    }
    return current_alert;
}

const getDataSinceLastAlertCheck = (dataset, lastCheckTime) => {

    let local_data = [];
    let localLastCheckTime
 
    if((dataset !== undefined)&&(dataset.length > 0)){    
        if (lastCheckTime === '') {                                         // if refresh or no recent data, limit data search to last 10 min 
            let currentDate = new Date();
            localLastCheckTime = new Date(currentDate.getTime() - 600000);  
        }
        else {
            localLastCheckTime = new Date(lastCheckTime);                  
        }

        for (var i = 0; i < dataset.length; i++){                        // Copy each data since lastCheckTime from oldest to newest
            if (new Date(dataset[i].x).getTime() > localLastCheckTime.getTime()) { 
                local_data.push(  {x: dataset[i].x, y: dataset[i].y});
            }                                  
        }
    }
    return local_data;
}

const getLastAlertMax7days = (dataset, typeOfAlert) => {

    let localAlertPoint = []
    if (dataset.length > 0) {
        // Filter only specific alerts
        let tmp_alert_tbl = []
        tmp_alert_tbl = dataset.filter(val => val.note[0] === typeOfAlert)

        tmp_alert_tbl.forEach((a) => {

            // check if less than 7 days
            if(checkDelayFrontend(7*24*60, a.sent, new Date()) === false){ 
                localAlertPoint.push({x: a.sent, y: a.note[1]})
            }
        })
    }
    return localAlertPoint
}

//Const to import functions in other files
const AlertManager = {
  getAudioInstance,
  manageFrontendAlerts,
  resetAudioAlert,
  getDataSinceLastAlertCheck,
  getLastAlertMax7days
};

export default AlertManager;
